import { render, staticRenderFns } from "./PublicRemoteWaiting.vue?vue&type=template&id=765e26b0&scoped=true&"
import script from "./PublicRemoteWaiting.vue?vue&type=script&lang=ts&"
export * from "./PublicRemoteWaiting.vue?vue&type=script&lang=ts&"
import style0 from "./PublicRemoteWaiting.vue?vue&type=style&index=0&id=765e26b0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765e26b0",
  null
  
)

export default component.exports